<template>
  <icon
    v-if="!isLoading"
    class="c-icon"
    :icon="icon"
    :width="width"
    :height="height"
  />
</template>

<script>
import Icon from 'vue-svgicon'

export default {
  components: { Icon },
  props: {
    width: String,
    height: String,
    icon: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  watch: {
    icon (newIcon, oldIcon) {
      /* istanbul ignore next */
      if (process.env.NODE_ENV !== 'development' && newIcon !== oldIcon) {
        this.loadIcon()
      }
    }
  },
  mounted () {
    this.loadIcon()
  },
  methods: {
    loadIcon () {
      this.isLoading = true
      /* istanbul ignore next */
      import('@/icons/' + (process.env.NODE_ENV !== 'development' ? this.icon : 'index.js')).then(() => {
        this.isLoading = false
      })
    }
  }
}
</script>
<style lang="scss">
.c-icon {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CIcon.vue